import { db } from "firebaseConfig";
import { addDoc, collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { lostItem } from "types/firestoreTypes";
import useLostItem from "hooks/useLostItem";
import Modal from "react-modal";
import getNowDate from "modules/getNowDate";
import DefaultTemplate from "components/templates/DefaultTemplate";
import BackButton from "components/molecules/BackButton";

Modal.setAppElement("#root");

const LostItem = () => {
    const { lostItems, getLostItems, isLoading } = useLostItem();
    if (isLoading) getLostItems();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [text, setText] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [id, setId] = useState("");

    const M = () => {
        const [name, setName] = useState("");
        const [tel, setTel] = useState("");
        const [text2, setText2] = useState("");
        return (
            <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        const d = {
                            name: name,
                            tel: tel,
                            text: text2,
                            date: getNowDate(),
                        };
                        setDoc(doc(db, `item_log/${id}`), d).then(() => {
                            const d: Pick<lostItem, "is_resolve"> = {
                                is_resolve: true,
                            };
                            updateDoc(doc(db, `lost_item/${id}`), d).then(
                                () => {
                                    getLostItems();
                                    setIsOpen(false);
                                }
                            );
                        });
                    }}
                >
                    名&emsp;&emsp;前:
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ width: "50%" }}
                    />
                    <br />
                    電話番号:
                    <input
                        type="text"
                        value={tel}
                        onChange={(e) => setTel(e.target.value)}
                        style={{ width: "50%" }}
                    />
                    <br />
                    備考
                    <br />
                    <textarea
                        value={text2}
                        onChange={(e) => setText2(e.target.value)}
                        rows={5}
                        style={{ width: "50%" }}
                    ></textarea>
                    <br />
                    <input type="submit" value="引き渡し完了" />
                    <button onClick={() => setIsOpen(false)}>キャンセル</button>
                </form>
            </Modal>
        );
    };

    return (
        <DefaultTemplate
            isAdmin={true}
            style={{
                textAlign: "center",
            }}
        >
            <BackButton />
            <h1>落とし物情報</h1>
            {isLoading ? (
                <h2>Now Loading...</h2>
            ) : lostItems.length === 0 ? (
                <h2>現在落とし物はありません</h2>
            ) : (
                <>
                    {lostItems.map((item) => {
                        return (
                            <div
                                key={item.id}
                                style={{
                                    border: "solid 1px",
                                    width: "80%",
                                    margin: "1% 10%",
                                }}
                            >
                                <h2>{item.title}</h2>
                                <span>{item.text}</span>
                                <br />
                                <span>{item.date}</span>
                                &emsp;
                                <button
                                    onClick={() => {
                                        setId(item.id);
                                        setIsOpen(true);
                                        // if (
                                        //     !window.confirm(
                                        //         "引き渡しが完了しましたか？"
                                        //     )
                                        // )
                                        //     return;
                                        // const d: Pick<lostItem, "is_resolve"> =
                                        //     { is_resolve: true };
                                        // updateDoc(
                                        //     doc(db, `lost_item/${item.id}`),
                                        //     d
                                        // ).then(() => {
                                        //     getLostItems();
                                        // });
                                    }}
                                >
                                    引き渡し
                                </button>
                            </div>
                        );
                    })}
                </>
            )}
            <M />
            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
            >
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        const data: lostItem = {
                            date: getNowDate(),
                            title: title,
                            text: text,
                            is_resolve: false,
                        };
                        addDoc(collection(db, "lost_item"), data).then(() => {
                            setIsModalOpen(false);
                            setTitle("");
                            setText("");
                            getLostItems();
                        });
                    }}
                >
                    <p>タイトル</p>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required={true}
                    />
                    <p>詳細</p>
                    <textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        style={{
                            width: "100%",
                            height: "10rem",
                        }}
                        required={true}
                    />
                    <br />
                    <input type="submit" value="追加" />
                </form>
            </Modal>
            <button onClick={() => setIsModalOpen(true)}>落とし物を追加</button>
        </DefaultTemplate>
    );
};

export default LostItem;
